import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import MarqueeBand from "../components/site/MarqueeBand";
import Services from "../components/site/Services";
import WhyChooseUs from "../components/site/WhyChooseUs";
import Gallery from "../components/site/Gallery";
import Testimonials from "../components/site/Testimonials";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingCTA from "../components/site/FloatingCTA";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#09090B] text-white min-h-screen">
      <Header />
      <main>
        <Hero />
        <MarqueeBand />
        <Services />
        <WhyChooseUs />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
